module.exports = __webpack_public_path__ + "static/media/lawler.27e3d0f3.png";